import instance from "@/services/axiosConfig";
import appInstance from "./applicationService/appinstance";

const addRole = (payload) =>
  instance.post("/superadminsettings/addrole", payload);
const getRole = () => appInstance.get("/superadminsettings/getroles");

const addEventType = (payload) =>
  instance.post("/superadmin/addevent", payload);

const checkEventType = (payload) =>
  instance.post("/superadmin/get-event-map", payload);

const getModuleOrdermetainfo = () =>
  instance.get(`/superadmin/get-table-metadata`);

const getNextAvaiblityevent = (payload) =>
  instance.get(`/superadmin/getnextevent/${payload}`);

const deleteEventType = (id) =>
  instance.put(`/superadmin/delete-event/${id}`, {});

const updateEventType = (payload) =>
  instance.put("/superadmin/update-event", payload);

const updateEventModule = (payload) =>
  instance.put("/superadmin/update-event-module", payload);
const getEventModule = (eventname) =>
  instance.get(`/superadmin/geteventmodule/${eventname}`);

const getTableChartdata = (payload) => {
  console.log("payloadpayload", payload?.filters?.ship_id);
  const getimonumber = localStorage.getItem("imo_number") || 0;
  return instance.post(
    `/superadmin/getallchartsdetails/${payload?.filters?.ship_id || getimonumber
    }`,
    payload
  );
};

const getallmenus = () => instance.get(`/superadmin/getallmenus`);

const getChartById = (id) => instance.get(`/superadmin/getchart/${id}`);

const syncModules = () => instance.get(`/superadmin/insert-table-metadata`);
const syncUserData = (payload) =>
  instance.post(`/create/getbackup-indexdb-superadmin`, payload);

const getBenchmarkColumns = (tablename) =>
  instance.get(`/create/getbenchmarkindex/${tablename}`);

const getAllEvents = (type) =>
  instance.get(`/superadmin/allevents${!type ? "" : `?report_type=${type}`}`);

const getAllCharts = (payload) =>
  instance.get("/superadmin/getallcharts", payload);

const addUserComments = (payload) =>
  instance.post("/superadmin/addcomments", payload);

const getUserComments = () => instance.get("/superadmin/getcomments");

const getRegressionCharts = () => instance.get("/superadmin/getregchart");

const updateChart = (payload) =>
  instance.put("/superadmin/updatechart", payload);

const deleteChart = (id) => instance.delete(`/superadmin/deletechart/${id}`);

const getAllShip = () => instance.get("/superadmin/shiplist");

const updateEvents = (payload) =>
  instance.post("/superadmin/update-event", payload);

const updateEventsMap = (payload) =>
  instance.post("/superadmin/update-event-map", payload);

const addChart = (payload) => instance.post("/superadmin/addchart", payload);

const getTableColumns = (type) =>
  instance.get(`/superadmin/getallcolumn/${type}`);

const createShipType = (payload) =>
  appInstance.post(`/superadminsettings/addshiptype`, payload);

const createOwner = (payload) =>
  appInstance.post(`/superadminsettings/owner-register`, payload);

const viewAllShiptype = () =>
  appInstance.get(`/superadminsettings/getallshipTypes`);

const viewAllOwners = () => appInstance.get(`/superadminsettings/getallowners`);

const createmodulegroup = (payload) =>
  instance.post(`/superadminsettings/createmodulegroup`, payload);

const createModulegroupToOwner = (payload) =>
  instance.post(`/superadminsettings/assignmoduletoowner`, payload);

const deletemodulegroup = (id) =>
  instance.delete(`/superadminsettings/deletemoduleassign/${id}`);

const viewallmodulegroup = () =>
  instance.get(`/superadminsettings/listmodulegroup`);

const getsinglemodulegroup = (id,type=null) =>
  instance.get(`/superadminsettings/modulegroup/${id}${type ? `?type=${type}` :""}`);

const deletemodulegroupbyname = (id) =>
  instance.patch(`/superadminsettings/deletetmodulegroup/${id}`);

const updatemodulegroupbyname = (payload) =>
  instance.put(`/superadminsettings/updatemodulegroup`, payload);
const updatemoduleassignment = (payload) =>
  instance.put(`/superadminsettings/updatemoduleassign`, payload);

const createCustomvalidation = (payload) =>
  instance.post(`/superadminsettings/addcustomvalidation`, payload);

const updateCustomvalidation = (payload) =>
  instance.put(`/superadminsettings/updatevalidationspecific-rules`, payload);

const deleteCustomValidation = (id) =>
  instance.delete(`/superadminsettings/delete-validationspecific/${id}`);

const viewmodulemappedGroup = () =>
  instance.get(`/superadminsettings/listmodulegroupassign`);

const viewallvalidationSpecificrules = () =>
  instance.get(`/superadminsettings/validation-specific-rules`);

const createChartassignment = (payload) =>
  instance.post(`/charts/assign-feature`, payload);

const updatechartassignments = (payload) =>
  instance.put(`/charts/updateAssignmentToOwner`, payload);
const getownersCharts = (reportType) =>
  instance.get(`/charts/getchartItemsByOwner/${reportType}`);

const getAllTemplate = () => instance.get(`/template`);
const createtemplate = (payload) => instance.post(`/template`, payload);
const updateTemplate = (payload) => instance.put(`/template`, payload);
// const syncMysqtoPg = (payload) =>
//   instance.post(`/superadminsettings/syncTable`, payload);

const getallModules = () => instance.get(`/create/viewmodule`);
const createTour = (payload) =>
  instance.post(`/superadminsettings/createtour`, payload);

const gettour = (tour_name) =>
  instance.get(`/superadminsettings/gettour/${tour_name}`);

const getalltour = () => instance.get(`/superadminsettings/getalltour`);
const updatetour = (payload) =>
  instance.put(`/superadminsettings/updateTour`, payload);
const getTourbyReport = (reportType) =>
  instance.get(`/superadminsettings/getReportwise/${reportType}`);


const saveExcelSheet = (payload) =>
  instance.post(`/workbook/save`, payload);

const getAllWorksheet = () =>
  instance.get(`/workbook`);

//MENU MANAGEMENT
const addmenu = (payload) =>
  instance.post(`/superadminsettings/menus`, payload);
const getallMenu = () =>
  instance.get(`/superadminsettings/menus`);
const updateMenu = (id, payload) =>
  instance.put(`/superadminsettings/menus/${id}`, payload);
const deletemenu = () =>
  instance.delete(`/superadminsettings/menus/${id}`, payload);

const getEmails = (payload) =>
  appInstance.post(`/seaflash/getemail`, payload);

const getemailalerts = () =>
  instance.get(`/schedular/getemailalerts`);





const superuserService = {
  getTableChartdata,
  getRegressionCharts,
  deleteEventType,
  updateEventsMap,
  updateEventType,
  addChart,
  getTableColumns,
  getAllCharts,
  deleteChart,
  updateChart,
  updateEvents,
  getAllShip,
  getAllEvents,
  addEventType,
  checkEventType,
  getNextAvaiblityevent,
  getModuleOrdermetainfo,
  syncModules,
  addUserComments,
  getUserComments,
  syncUserData,
  createShipType,
  viewAllShiptype,
  viewAllOwners,
  createOwner,
  createmodulegroup,
  viewallmodulegroup,
  viewmodulemappedGroup,
  createChartassignment,
  updatechartassignments,
  getownersCharts,
  viewallvalidationSpecificrules,
  deletemodulegroup,
  createModulegroupToOwner,
  deletemodulegroupbyname,
  updatemodulegroupbyname,
  createCustomvalidation,
  deleteCustomValidation,
  updatemoduleassignment,
  updateCustomvalidation,
  addRole,
  getRole,
  getBenchmarkColumns,
  getChartById,
  createtemplate,
  getAllTemplate,
  updateTemplate,
  getallModules,
  getsinglemodulegroup,
  createTour,
  gettour,
  getalltour,
  updatetour,
  getTourbyReport,getemailalerts,
  getEventModule, addmenu, getallMenu, updateMenu, deletemenu,
  updateEventModule, saveExcelSheet, getAllWorksheet, getEmails, getallmenus
};
export default superuserService;
